import React, { useEffect, useState } from "react";
import "./TirumalaDC.css";
import axios from "axios";
import logoImage from "../logo.webp";
import SuccessModal from "../Modals/SuccessModal/SuccessModal";
import ErrorModal from "../Modals/ErrorModal/ErrorModal";
import ClipLoader from "react-spinners/ClipLoader";
import { branchList } from "../LenderBranchLists/LenderBranchLists";
import { Info } from "lucide-react";
import InfoModal from "../Modals/InfoModal/InfoModal.js";

import HealthDialog from "./HealthDialog";
import { styles, healthQuestion, pdfDownloadLink, memmberShipFormLink } from "./constants.js";
import {
  validateEmail,
  validatePhoneNumber,
  validatePincode,
  validateAadhaar,
  validatePAN,
  calculateAge,
  calculateExpiryDate,
  calculateIssueDate,
  checkFileSize,
  transformPricingData,
  transformPricingDataGpa,
} from "./utils";
import {
  initialLoanDetails,
  initialResponses,
  initialImagePreviews,
  initialFormData,
} from "./initialState";
import { getPricingGTL, getPricingGPA, generateOTP, verifyOTP, singleUpload, fetchUserByAadhar, updateLoanDetails, updateLoanStatus  } from "./api";



const TirumalaDC = () => {

  const [infoOpen, setInfoOpen] = useState(false);
const [infoMsg, setInfoMsg] = useState("");
const [infoVariant, setInfoVariant] = useState("info"); 

  const override = {
    position: "absolute",
    top: "50%",
    left: "50%",
    backgroundColor: "green",
    transform: "translate(-50%, -50%)",
    display: "block",
    margin: "auto",
    borderColor: "grey",
  };
  
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = () => setShowPopup(!showPopup);
  const handleSuccessClose = () => setDataIsSent(false);
  const handleErrorClose = () => setDataIsNotSent(false);

  const [flashcode, setFlashcode] = useState("");
  const [count, setCount] = useState(1);
  const [totalLoanAmount, setTotalLoanAmount] = useState(0);
  const [loanDetails, setLoanEntries] = useState(initialLoanDetails);

  const [loading, setLoading] = useState(false);
  const [popupResponse, setPopupResponse] = useState("");
  const [ErrorResponse, setErrorResponse] = useState("");
  const [ageLimitExceed, setAgeLimitExceed] = useState(false);

  const [open, setOpen] = useState(false);
  const [hasAnyYesAnswer, setHasAnyYesAnswer] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [isDigital, setIsDigital] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const [responses, setResponses] = useState(initialResponses);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [singleManualForm, setSingleManualForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState("");
  const [resendTimer, setResendTimer] = useState(30);

  const [dataIsSent, setDataIsSent] = useState(false);
  const [dataIsNotSent, setDataIsNotSent] = useState(false);

  const [pricingData, setPricingData] = useState({});
  const [pricingDataGpa, setPricingDataGpa] = useState({});

  const [tenure, setTenure] = useState("");
  const [coverage, setCoverage] = useState("");
  const [premiumExcGST, setPremiumExcGST] = useState("");
const [fetchingByAadhar, setFetchingByAadhar] = useState(false);
const [fetchedByAadhar, setFetchedByAadhar] = useState(false);

  const [existingLoans, setExistingLoans] = useState([]);
const [existingLoansTotal, setExistingLoansTotal] = useState(0);

// new state for asking disable date
const [showDisableDateModal, setShowDisableDateModal] = useState(false);
const [disableDateForLoan, setDisableDateForLoan] = useState(""); // YYYY-MM-DD
const [pendingToggleLoan, setPendingToggleLoan] = useState(null);

// --- new state ---

// Aadhaar formatter for API
const toDashedAadhaar = (val = "") => {
  const digits = String(val).replace(/\D/g, "");
  if (digits.length !== 12) return "";              // invalid -> blank
  return `${digits.slice(0,4)}-${digits.slice(4,8)}-${digits.slice(8,12)}`;
};

// Are all current loan rows fully filled?
const areAllLoanRowsComplete = () => {
  if (!loanDetails.length) return false;
  const allFilled = loanDetails.every((e) =>
    String(e.loanAmount).trim() &&
    String(e.loanSanctionDate).trim() &&
    String(e.loanEndDate).trim() &&
    String(e.loanType).trim() &&
    String(e.lenderBranch).trim() &&
    String(e.loanAccountNumber).trim()
  );
  // also ensure we have no per-row validation errors active
  const hasRowErrors = Object.entries(errors).some(([k, v]) =>
    v && (
      k.startsWith("loanAmount_") ||
      k.startsWith("loanSanctionDate_") ||
      k.startsWith("loanEndDate_") ||
      k.startsWith("loanType_") ||
      k.startsWith("lenderBranch_") ||
      k.startsWith("loanAccountNumber_")
    )
  );
  return allFilled && !hasRowErrors;
};

// enable Update Loans only when autofilled AND we have dashed Aadhaar + flashcode + complete rows
const canUpdateLoans = () => {
  if (!fetchedByAadhar) return false;
  const dashed = toDashedAadhaar(formData.aadhar);
  return Boolean(dashed && flashcode && areAllLoanRowsComplete()&& String(formData.premiumIncGST || "").trim() );
};
const resetAndPrefillFromAadhaar = (user) => {
  // clear any new, unsaved loan rows & premium first
  resetNewLoansAndPremium();

  // (optional) clear existingLoans until we hydrate
  setExistingLoans([]);
  setExistingLoansTotal(0);

  // now hydrate with the fetched profile
  prefillFromAadharResponse(user);

  // mark autofill mode on
  setFetchedByAadhar(true);
};

const resetNewLoansAndPremium = () => {
  setLoanEntries([
    {
      loanAmount: "",
      loanSanctionDate: "",
      loanEndDate: "",
      loanType: "",
      lenderBranch: "",
      loanAccountNumber: "",
    },
  ]);
  setCount(1);
  setTotalLoanAmount(0);
  setCoverage("");
  setPremiumExcGST("");
  setFormData((prev) => ({ ...prev, premiumIncGST: "" }));

  // clear loan-row errors
  setErrors((prev) => {
    const next = { ...prev };
    Object.keys(next).forEach((k) => {
      if (
        k.startsWith("loanAmount_") ||
        k.startsWith("loanSanctionDate_") ||
        k.startsWith("loanEndDate_") ||
        k.startsWith("loanType_") ||
        k.startsWith("lenderBranch_") ||
        k.startsWith("loanAccountNumber_")
      ) {
        delete next[k];
      }
    });
    return next;
  });
};


const handleUpdateLoans = async () => {
  // extra guard
  if (!canUpdateLoans()) return;

  const aadharDashed = toDashedAadhaar(formData.aadhar);

  // Normalize loanType to something safe for API (lowercase)
  const payloadLoans = loanDetails.map((d) => ({
    loanAmount: Number(d.loanAmount),
    loanSanctionDate: d.loanSanctionDate, // YYYY-MM-DD
    loanEndDate: d.loanEndDate,           // YYYY-MM-DD
    loanType: String(d.loanType || "").toLowerCase(),
    lenderBranch: d.lenderBranch,
    loanAccountNumber: d.loanAccountNumber,
  }));

  const body = {
    aadhar: aadharDashed,
    flashcode: flashcode,
    loanDetails: payloadLoans,
  };

 try {
    setLoading(true);
    const res = await updateLoanDetails(body);

    // Backend message only
    const msg = res?.data?.message || "Loans updated";
    setInfoMsg(msg);

    // choose variant by message if you like; default to success for 200
    const lower = msg.toLowerCase();
    if (lower.includes("duplicate")) setInfoVariant("warning");
    else setInfoVariant("success");

    setInfoOpen(true);
     // ✅ refresh after short delay so user sees message
    setTimeout(() => {
      window.location.reload();
    }, 2000);

  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.response?.data ||
      err?.message ||
      "Failed to update loans";
    setInfoMsg(msg);
    setInfoVariant("error");
    setInfoOpen(true);
  } finally {
    setLoading(false);
  }

};


const formatINR = (n) =>
  isNaN(n) ? "₹ 0" : `₹ ${Number(n).toLocaleString("en-IN")}`;

const dmy = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso; // fallback if not valid ISO
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}-${mm}-${yy}`;
};

  const [formData, setFormData] = useState({
    ...initialFormData,
    // we won’t use these three in UI anymore
    aadharFrontPage: null,
    aadharBackPage: null,
    panImage: null,
  });

  const [imagePreviews, setImagePreviews] = useState({
    ...initialImagePreviews,
    aadharFrontPage: null,
    aadharBackPage: null,
    panImage: null,
  });

  // Real-time field-level errors
  const [errors, setErrors] = useState({});

  const stripDashes = (val = "") => val.replace(/\D/g, "");

  const safeStr = (val) => (val == null ? "" : String(val));

  // helpers for stable sorting
const ts = (s) => (s ? new Date(s).getTime() || 0 : 0);

const sortLoans = (arr = []) =>
  [...arr].sort((a, b) => {
    // 1) sanction date (oldest first)
    const s = ts(a.loanSanctionDate) - ts(b.loanSanctionDate);
    if (s) return s;

    // 2) end date
    const e = ts(a.loanEndDate) - ts(b.loanEndDate);
    if (e) return e;

    // 3) id (if present)
    if (a.id != null && b.id != null && a.id !== b.id) return a.id - b.id;

    // 4) account number
    const acc = String(a.loanAccountNumber ?? "").localeCompare(String(b.loanAccountNumber ?? ""));
    if (acc) return acc;

    // 5) amount
    const amt = (Number(a.loanAmount) || 0) - (Number(b.loanAmount) || 0);
    if (amt) return amt;

    // 6) type
    const typ = String(a.loanType ?? "").localeCompare(String(b.loanType ?? ""));
    if (typ) return typ;

    // 7) branch
    return String(a.lenderBranch ?? "").localeCompare(String(b.lenderBranch ?? ""));
  });


 const prefillFromAadharResponse = (u) => {
  if (!u || typeof u !== "object") return;
setFlashcode(safeStr(u.flashPrefix) || safeStr(u.flashCode) || "");
  // --- normalize ---
  const normGender = (u.gender || "").toString().trim().toLowerCase();
  const gender = normGender === "male" || normGender === "female" ? normGender : "";

  const allowedRelations = ["son","daughter","father","mother","spouse","brother","sister"];

const normRelation = (val) => {
  const r = (val || "").toString().trim().toLowerCase();
  return allowedRelations.includes(r) ? r : "";
};

  setFormData((prev) => ({
    ...prev,
    customerId:       safeStr(u.customerId) || prev.customerId,
    employeeId:       safeStr(u.employeeId) || prev.employeeId,
    firstname:        safeStr(u.firstname) || prev.firstname,
    lastname:         safeStr(u.lastname) || prev.lastname,
    dateOfBirth:      safeStr(u.dateOfBirth) || prev.dateOfBirth, // YYYY-MM-DD suitable for <input type="date">
    gender:           gender || prev.gender,
    address:          safeStr(u.address) || prev.address,
    pincode:          safeStr(u.pincode) || prev.pincode,
    state:            safeStr(u.countryState) || prev.state || "",   // safe against null/undefined
    mobileNumber:     safeStr(u.mobileNumber).replace(/\D/g, "").slice(0, 10) || prev.mobileNumber,
    emailId:          safeStr(u.emailId) || prev.emailId,
    aadhar:           safeStr(u.aadhar).replace(/\D/g, "") || prev.aadhar,                  // digits only
    pan:              safeStr(u.pan) || prev.pan,
    occupation:       safeStr(u.occupation) || prev.occupation,
nomineeRelation:  normRelation(u.nomineeRelation) || prev.nomineeRelation,

    nomineeName:      safeStr(u.nomineeName) || prev.nomineeName,
    nomineeDob:       safeStr(u.nomineeDob) || prev.nomineeDob,       // YYYY-MM-DD
    nomineeAadharNo:  safeStr(u.nomineeAadharNo).replace(/\D/g, "") || prev.nomineeAadharNo, // digits only
    nomineePanNo:     safeStr(u.nomineePanNo) || prev.nomineePanNo,
    premiumIncGST:    prev.premiumIncGST,
  }));

  // clear field-level errors for the fields we just populated
  setErrors((prev) => {
    const next = { ...prev };
    [
      "customerId","firstname","lastname","dateOfBirth","gender","address",
      "pincode","mobileNumber","emailId","aadhar","pan","occupation",
      "nomineeRelation","nomineeName","nomineeDob","nomineeAadharNo","nomineePanNo"
    ].forEach((k) => delete next[k]);
    return next;
  });

  // map tenure from months (e.g., 12) → your select keys ("1_years","2_years","3_years"...)
  if (u.tenure) {
    const years = Math.max(1, Math.round((+u.tenure || 12) / 12)); // 12→1, 24→2, etc.
    const key = `${Math.min(years, 5)}_years`; // your pricing caps at 3, but safe to 5
    if (pricingData[key]) setTenure(key);
  }

  // ----- Existing Loans (display-only; DO NOT prefill rows) -----
let loans = Array.isArray(u.loanDetails) ? u.loanDetails : [];

  const displayLoans = loans.map((d) => ({
    id:               d?.id ?? null,
    loanAmount:        d?.loanAmount ?? "",
    loanSanctionDate:  d?.loanSanctionDate ?? "",
    loanEndDate:       d?.loanEndDate ?? "",
    loanType:          d?.loanType ?? "",
    lenderBranch:      d?.lenderBranch ?? "",
    loanAccountNumber: d?.loanAccountNumber ?? "",
    loanStatus:        d?.loanStatus ?? "",
  }));

setExistingLoans(sortLoans(displayLoans));

  const existingSum = displayLoans.reduce((t, x) => t + (parseFloat(x.loanAmount) || 0), 0);
  setExistingLoansTotal(existingSum);

  // IMPORTANT: do NOT touch user-editable loan rows or totalLoanAmount here.
  // (We are NOT calling setLoanEntries / setTotalLoanAmount)
};

const [togglingLoanId, setTogglingLoanId] = useState(null);

const refreshLoansOnly = async () => {
  const digits = (formData?.aadhar || "").replace(/\D/g, "");
  if (digits.length !== 12) return;
  const dashed = `${digits.slice(0,4)}-${digits.slice(4,8)}-${digits.slice(8,12)}`;

  const res = await fetchUserByAadhar(dashed);
 let loans = Array.isArray(res?.data?.loanDetails) ? res.data.loanDetails : [];

const display = loans.map(d => ({
  id: d?.id ?? null,
  loanAmount: d?.loanAmount ?? "",
  loanSanctionDate: d?.loanSanctionDate ?? "",
  loanEndDate: d?.loanEndDate ?? "",
  loanType: d?.loanType ?? "",
  lenderBranch: d?.lenderBranch ?? "",
  loanAccountNumber: d?.loanAccountNumber ?? "",
  loanStatus: d?.loanStatus ?? "",
}));

// sort by sanction date (oldest first)
display.sort((a, b) => new Date(a.loanSanctionDate) - new Date(b.loanSanctionDate));

setExistingLoans(sortLoans(display));


  setExistingLoansTotal(display.reduce((t,x)=>t+(+x.loanAmount||0),0));
};


// Clear all fields/state except the Aadhaar the user just typed
const clearAllButAadhaar = (aadhaarDigits = "") => {
  // 1) reset new loan rows, totals, premium & related errors
  resetNewLoansAndPremium();

  // 2) wipe existing loans (read-only block)
  setExistingLoans([]);
  setExistingLoansTotal(0);

  // 3) exit autofill mode & clear flashcode
  setFetchedByAadhar(false);
  setFlashcode("");

  // 4) reset form but KEEP Aadhaar
  setFormData({
    ...initialFormData,
    aadhar: aadhaarDigits,    // keep what user typed
    aadharFrontPage: null,
    aadharBackPage: null,
    panImage: null,
    premiumIncGST: "",
  });

  // 5) reset previews + image errors
  setImagePreviews({
    ...initialImagePreviews,
    aadharFrontPage: null,
    aadharBackPage: null,
    panImage: null,
    longQuestionnaire: null,
    membership: null,
  });
  setImageErrors({ longQuestionnaire: "", membership: "" });

  // 6) validations
  setErrors({});
  validateFieldLive("aadhar", aadhaarDigits);

  // 7) OTP/health bits
  setOtpVerified(false);
  setResponses(initialResponses);
  setPhoneNumber("");
  setSingleManualForm(false);
  setOtp("");
  setOtpSent(false);
  setIsManual(false);
  setIsDigital(false);
  setHasAnyYesAnswer(false);

  // 8) other derived
  setTotalLoanAmount(0);
  setCoverage("");
  setPremiumExcGST("");
};


  // ---------- Pricing ----------
  useEffect(() => {
    (async () => {
      try {
        const response = await getPricingGTL();
        const transformed = transformPricingData(response.data);
        setPricingData(transformed);
        if (Object.keys(transformed).length > 0) {
          setTenure(Object.keys(transformed)[0]);
        }
      } catch (e) {
        console.error("Error fetching pricing GTL:", e);
      }
    })();
  }, []);
useEffect(() => {
  const raw = formData?.aadhar || "";
  const digits = raw.replace(/\D/g, "");
  if (digits.length !== 12) return;

  const dashed = `${digits.slice(0,4)}-${digits.slice(4,8)}-${digits.slice(8,12)}`;

  setFetchingByAadhar(true);
  const controller = new AbortController();

  const t = setTimeout(async () => {
    try {
      const res = await fetchUserByAadhar(dashed, { signal: controller.signal });
      if (res?.data) {
        resetAndPrefillFromAadhaar(res.data); // this sets fetchedByAadhar(true)
      }
    } catch (err) {
      const status = err?.response?.status;

      // ✅ ONLY clear if we were in autofill mode already, and the new Aadhaar is not found
      if (status === 404 && fetchedByAadhar) {
        clearAllButAadhaar(digits);

        // optional: show a small info toast
        setInfoMsg("No customer found for this Aadhaar. Please enter details manually.");
        setInfoVariant("warning");
        setInfoOpen(true);
      }

      // Regardless of error, leave fetchedByAadhar false after this attempt
      setFetchedByAadhar(false);
    } finally {
      setFetchingByAadhar(false);
    }
  }, 300);

  return () => {
    clearTimeout(t);
    controller.abort();
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [formData.aadhar]);


  useEffect(() => {
    (async () => {
      try {
        const response = await getPricingGPA();
        const transformed = transformPricingDataGpa(response.data);
        setPricingDataGpa(transformed);
      } catch (e) {
        console.error("Error fetching pricing GPA:", e);
      }
    })();
  }, []);

  // Coverage bucket update
  useEffect(() => {
    if (totalLoanAmount && pricingData[tenure]) {
      const amounts = Object.keys(pricingData[tenure])
        .map(Number)
        .sort((a, b) => a - b);
      let closest = amounts.find((a) => a >= totalLoanAmount);
      if (!closest) closest = amounts[amounts.length - 1];
      setCoverage(closest);
    }
  }, [totalLoanAmount, tenure, pricingData]);

  // Premium calculation
  useEffect(() => {
    if (totalLoanAmount) {
      const finalPremium = calculatePremium(totalLoanAmount, tenure);
      setFormData((prev) => ({ ...prev, premiumIncGST: finalPremium }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalLoanAmount, tenure]);

  const calculatePremium = (loanAmount, tenureStr) => {
    const tenureNumber = parseInt((tenureStr || "0_years").split("_")[0], 10);
    const adjustedTenure = tenureNumber > 3 ? 3 : tenureNumber || 1;
    const tenureKey = `${adjustedTenure}_years`;

    if (!pricingData[tenureKey] || !pricingDataGpa[tenureKey]) {
      return "N/A";
    }

    const getPremiumForAmount = (amount, source) => {
      const amounts = Object.keys(source[tenureKey])
        .map(Number)
        .sort((a, b) => a - b);
      let closest = amounts.find((amt) => amt >= amount);
      if (!closest) closest = amounts[amounts.length - 1];
      let base = source[tenureKey][closest];
      return parseFloat(base.toString().replace(/,/g, ""));
    };

    let total = 0;
    if (loanAmount > 3000000) {
      const baseAmount = 3000000;
      const excessAmount = loanAmount - baseAmount;
      total = getPremiumForAmount(baseAmount, pricingData) + getPremiumForAmount(excessAmount, pricingDataGpa);
    } else {
      total = getPremiumForAmount(loanAmount, pricingData);
    }

    setPremiumExcGST(total);
    const withTax = (total + total * 0.18).toFixed(3);
    return Math.ceil(withTax);
  };

  // ---------- DOGH ----------
  const handleResponseChange = (key, value) => {
    setResponses((prev) => {
      const updated = { ...prev, [key]: value };
      const allAnswered = Object.values(updated).every((r) => r !== "");
      const hasYes = Object.values(updated).includes("yes");
      if (allAnswered && hasYes) {
        setSingleManualForm(true);
        setHasAnyYesAnswer(true);
      }
      if (allAnswered && !hasYes) {
        setSingleManualForm(false);
        setHasAnyYesAnswer(false);
      }
      return updated;
    });
  };

 const handleSubmitTnc = () => {
  if (isDigital && !otpVerified) {
    setInfoMsg("Please verify OTP before proceeding.");
    setInfoVariant("warning");   // or "error" if you prefer
    setInfoOpen(true);
    return;
  }

  setInfoMsg("Form submitted successfully!");
  setInfoVariant("success");
  setInfoOpen(true);
};


  // ---------- OTP ----------
  const handlePhoneChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    setPhoneNumber(input.slice(0, 10));
    // reflect to formData.mobileNumber too
    setFormData((p) => ({ ...p, mobileNumber: input.slice(0, 10) }));
    // real-time validate
    setErrors((prev) => ({
      ...prev,
      mobileNumber: input.length === 10 && validatePhoneNumber(input) ? "" : "Invalid Mobile Number",
    }));
  };

  const handleSendOTP = async () => {
    if (phoneNumber.length !== 10) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }
    try {
      setError("");
      await generateOTP(phoneNumber);
      setOtpSent(true);
      setOtp("");
      let timer = 30;
      setResendTimer(timer);
      const interval = setInterval(() => {
        timer--;
        setResendTimer(timer);
        if (timer === 0) clearInterval(interval);
      }, 1000);
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
    }
  };

  const handleOtpChange = (e) => setOtp(e.target.value);

  const handleVerifyOTP = async () => {
    if (otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }
  try {
  const verifyotp = await verifyOTP(phoneNumber, otp);
  if (verifyotp.data.message === "OTP verified success") {
    setError("");
    setOtpVerified(true);

    // ✅ Show success in InfoModal instead of alert
    setInfoMsg("OTP Verified Successfully!");
    setInfoVariant("success");
    setInfoOpen(true);
  } else {
    setError("Invalid OTP. Please try again.");

    // ✅ Show error in InfoModal
    setInfoMsg("Invalid OTP. Please try again.");
    setInfoVariant("error");
    setInfoOpen(true);
  }
} catch (e) {
  console.error("Login Error:", e);

  setInfoMsg("Something went wrong during OTP verification. Please try again.");
  setInfoVariant("error");
  setInfoOpen(true);
}

  };

  const handleResendOTP = () => {
    if (resendTimer === 0) handleSendOTP();
  };

  // ---------- Real-time field validation helpers ----------
  const setFieldError = (name, message = "") =>
    setErrors((prev) => ({
      ...prev,
      [name]: message,
    }));

  const validateFieldLive = (name, value) => {
    switch (name) {
      case "customerId":
        setFieldError(name, value.trim() ? "" : "This field is required");
        break;
      case "firstname":
      case "lastname":
      case "address":
      case "state":
      case "occupation":
        setFieldError(name, value.trim() ? "" : "This field is required");
        break;
      case "dateOfBirth":
        setFieldError(name, value ? "" : "This field is required");
        break;
      case "emailId":
        setFieldError(name, value && validateEmail(value) ? "" : "Invalid Email Address");
        break;
      case "pincode":
        setFieldError(name, value && validatePincode(value) ? "" : "Invalid Pincode");
        break;
      case "aadhar":
        setFieldError(name, value && validateAadhaar(value) ? "" : "Invalid Aadhaar Number");
        break;
      case "pan":
        setFieldError(name, value && validatePAN(value) ? "" : "Invalid PAN Number");
        break;
      case "nomineeName":
        setFieldError(name, value.trim() ? "" : "This field is required");
        break;
      case "nomineeRelation":
        setFieldError(name, value ? "" : "This field is required");
        break;
      case "nomineeDob":
        setFieldError(name, value ? "" : "This field is required");
        break;
      case "nomineeAadharNo":
        setFieldError(name, value && validateAadhaar(value) ? "" : "Invalid Aadhaar Number");
        break;
      case "nomineePanNo":
        setFieldError(name, value ? "" : "This field is required");
        break;
      default:
        break;
    }
  };

  // ---------- Controlled field changes ----------
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "customerId") {
      const regex = /^[a-zA-Z0-9]*$/;
      if (!regex.test(value)) return;
    }

     // Aadhaar: if autofetched and user edits, clear new loans + premium
 if (name === "aadhar") {
   const numericAadhaar = value.replace(/\D/g, "").slice(0, 12);
   if (fetchedByAadhar && numericAadhaar !== formData.aadhar) {
     resetNewLoansAndPremium();
     // (Optional) break "autofilled" mode until next fetch:
    // setFetchedByAadhar(false);
   }
   setFormData((prev) => ({ ...prev, aadhar: numericAadhaar }));
   validateFieldLive("aadhar", numericAadhaar);
   return;
 }

    if (name === "mobileNumber") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, mobileNumber: numericValue }));
      setPhoneNumber(numericValue);
      setErrors((prev) => ({
        ...prev,
        mobileNumber: numericValue.length === 10 && validatePhoneNumber(numericValue) ? "" : "Invalid Mobile Number",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
      validateFieldLive(name, value);
    }
  };

  // DOB – update age + validation live
  useEffect(() => {
    if (!formData.dateOfBirth) return;
    const age = calculateAge(formData.dateOfBirth);
    setAgeLimitExceed(age >= 65);
    setFormData((prev) => ({ ...prev, age }));
    // error for age/dob
    setErrors((prev) => ({ ...prev, dateOfBirth: formData.dateOfBirth ? "" : "This field is required" }));
  }, [formData.dateOfBirth]);

  const handleDobChange = (e) => {
    const dateOfBirth = e.target.value;
    setFormData((prev) => ({ ...prev, dateOfBirth }));
  };

  const handleNomineeDobChange = (e) => {
    const nomineeDob = e.target.value;
    setFormData((prev) => ({ ...prev, nomineeDob }));
    setFieldError("nomineeDob", nomineeDob ? "" : "This field is required");
  };

  // ---------- Loans ----------
  const handleLoanChange = (e, index) => {
    const { name, value } = e.target;
    const [fieldName, fieldIndex] = name.split("_");
    if (parseInt(fieldIndex, 10) !== index) return;

    const updated = [...loanDetails];
    updated[index] = { ...updated[index], [fieldName]: value };
    setLoanEntries(updated);

    // total
    const newTotal = updated.reduce((t, entry) => t + (parseFloat(entry.loanAmount) || 0), 0);
    setTotalLoanAmount(newTotal);

    // live validation for this loan row
  // live validation for this loan row
const key = `${fieldName}_${index}`;
let msg = "";

if (
  (fieldName === "loanAmount" && !String(value).trim()) ||
  (fieldName === "loanSanctionDate" && !String(value).trim()) ||
  (fieldName === "loanEndDate" && !String(value).trim()) ||
  (fieldName === "loanType" && !String(value).trim()) ||
  (fieldName === "lenderBranch" && !String(value).trim()) ||
  (fieldName === "loanAccountNumber" && !String(value).trim())
) {
  msg = (fieldName.replace(/([A-Z])/g, " $1").trim() + " is required");
}

setErrors(prev => {
  const next = { ...prev };
  if (msg) next[key] = msg;     // set error
  else delete next[key];        // ✅ remove key entirely when valid
  return next;
});

  };

  const addMoreLoans = (e) => {
    e.preventDefault();
    if (count < 15) {
      setLoanEntries([
        ...loanDetails,
        { loanAmount: "", loanSanctionDate: "", loanEndDate: "", loanType: "", lenderBranch: "", loanAccountNumber: "" },
      ]);
      setCount((c) => c + 1);
    }
  };

const handleDeleteLoan = (index) => {
  const updated = loanDetails.filter((_, i) => i !== index);
  setLoanEntries(updated);

  // Recompute total
  const newTotal = updated.reduce((t, entry) => t + (parseFloat(entry.loanAmount) || 0), 0);
  setTotalLoanAmount(newTotal);

  // Remove ALL loan-related error keys to avoid stale indices
  setErrors((prev) => {
    const prefixes = [
      "loanAmount_",
      "loanSanctionDate_",
      "loanEndDate_",
      "loanType_",
      "lenderBranch_",
      "loanAccountNumber_",
    ];
    const next = {};
    for (const [k, v] of Object.entries(prev)) {
      const isLoanError = prefixes.some((p) => k.startsWith(p));
      if (!isLoanError) next[k] = v; // keep non-loan errors
    }

    // (Optional) Re-validate remaining rows and add errors back with new indices
    updated.forEach((entry, i) => {
      if (!String(entry.loanAmount).trim()) next[`loanAmount_${i}`] = "Loan Amount is required";
      if (!String(entry.loanSanctionDate).trim())
        next[`loanSanctionDate_${i}`] = "Loan Sanction Date is required";
      if (!String(entry.loanEndDate).trim())
        next[`loanEndDate_${i}`] = "Loan End Date is required";
      if (!String(entry.loanType).trim()) next[`loanType_${i}`] = "Loan Type is required";
      if (!String(entry.lenderBranch).trim())
        next[`lenderBranch_${i}`] = "Lender Branch is required";
      if (!String(entry.loanAccountNumber).trim())
        next[`loanAccountNumber_${i}`] = "Loan Account Number is required";
    });

    return next;
  });
  };

  // ---------- File change (for the two PDFs only) ----------
  const [imageErrors, setImageErrors] = useState({
    longQuestionnaire: "",
    membership: "",
  });

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files?.[0];
    if (!file) return;

    // Only longQuestionnaire or membership are expected now
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreviews((p) => ({ ...p, [name]: reader.result }));
    };
    reader.readAsDataURL(file);

    setFormData((prev) => ({ ...prev, [name]: file }));

    // size check
    if (!checkFileSize(file)) {
      setImageErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} exceeds 1 Mb. Please upload a smaller file.`,
      }));
    } else {
      setImageErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleRemoveImage = (name) => {
    setImagePreviews((p) => ({ ...p, [name]: null }));
    setFormData((p) => ({ ...p, [name]: null }));
  };

  // ---------- Derived flags ----------
  const areRequiredFieldsFilled = () => {
    const basicOk =
      formData.customerId.trim() &&
      formData.firstname.trim() &&
      formData.lastname.trim() &&
      formData.dateOfBirth &&
      String(formData.age) !== "" &&
      formData.gender.trim() &&
      formData.address.trim() &&
      validatePincode(formData.pincode) &&
      validatePhoneNumber(formData.mobileNumber) &&
      validateEmail(formData.emailId) &&
      formData.state.trim() &&
      !ageLimitExceed;

    const hasNoBasicErrors = ![
      "customerId",
      "firstname",
      "lastname",
      "dateOfBirth",
      "age",
      "gender",
      "address",
      "pincode",
      "mobileNumber",
      "emailId",
      "state",
    ].some((k) => errors[k]);

    return Boolean(basicOk && hasNoBasicErrors);
  };

  const areLoanDetailsFieldsFilled = () => {
    const loanOk =
      formData.aadhar.trim() &&
      validatePAN(formData.pan) &&
      formData.nomineeName.trim() &&
      formData.nomineeRelation &&
      formData.nomineeDob &&
      validateAadhaar(formData.nomineeAadharNo) &&
      formData.nomineePanNo.trim() &&
      formData.occupation.trim() &&
      loanDetails.every(
        (e) =>
          String(e.loanAmount).trim() &&
          String(e.loanSanctionDate).trim() &&
          String(e.loanEndDate).trim() &&
          String(e.loanType).trim() &&
          String(e.lenderBranch).trim() &&
          String(e.loanAccountNumber).trim()
      );

    // check if any loan field error keys exist
const loanErrors = Object.entries(errors).some(([k, v]) =>
  v && (                       // ✅ message must be non-empty
    k.startsWith("loanAmount_") ||
    k.startsWith("loanSanctionDate_") ||
    k.startsWith("loanEndDate_") ||
    k.startsWith("loanType_") ||
    k.startsWith("lenderBranch_") ||
    k.startsWith("loanAccountNumber_")
  )
);
    return Boolean(loanOk && !loanErrors);
  };

  const isHealthFormValid =
    ((isDigital && otpVerified && Object.values(responses).every((v) => v) && Boolean(imagePreviews.longQuestionnaire)) ||
      (Object.values(responses).some((v) => v === "yes") && Boolean(imagePreviews.longQuestionnaire))) ||
    (isManual && Boolean(imagePreviews.membership)) ||
    Object.values(responses).every((v) => v === "no");

  // ---------- Submit ----------
  const handleSubmit = async (e) => {
    e.preventDefault();

    // block submit if live validations fail
  if (!areRequiredFieldsFilled() || !areLoanDetailsFieldsFilled()) {
  setInfoMsg("Please fix the highlighted errors before submitting.");
  setInfoVariant("warning");  // or "error" if you prefer
  setInfoOpen(true);
  return;
}


    const transformedTenure = tenure.split("_")[0];
    const fullname = `${formData.firstname} ${formData.lastname}`;
    const expiryDate = calculateExpiryDate(transformedTenure);
    const issueDate = calculateIssueDate();
    const updatedTenure = Number(transformedTenure || 1);

    const {
      longQuestionnaire,
      membership,
      state,
      ...formDataWithoutFiles
    } = formData;

    const formDataToSend = {
      ...formDataWithoutFiles,
      partnerId: 24,
      tenure: updatedTenure,
      loanDetails,
      totalLoanAmount,
      fullname,
      expiryDate,
      issueDate,
      gpaCoverage: 0,
      gmcCoverage: 0,
      txnDate: "",
      insuranceCompanyNames: totalLoanAmount > 3000000 ? ["aviva", "universal"] : ["aviva"],
      tpaNames: totalLoanAmount > 3000000 ? ["aviva", "universal"] : ["aviva"],
      otherInsured: [],
      certificate: [],
      uhid: [],
      hasAnyYesAnswer,
      isDigital,
      isManual,
      longQuestionnaireUrl: null,
      membershipUrl: null,
      totalNoOfLives: 1,
      adult: 1,
      child: 1,
      masterPolicyNumber: "",
      source: "form",
      gtlCoverage: 0,
      aadharFrontPage: "aadhar_front_image",
      aadharBackPage: "aadhar_back_image",
      panImage: "pan_image",
      mcq: [responses],
      age: Number(formData.age),
      employeeId: formData.customerId,
      customerId: Number(formData.customerId),
      premiumExcGST: Number(premiumExcGST),
    };

    try {
      const formPayload = new FormData();
      formPayload.append("customerInsurance", JSON.stringify(formDataToSend));

      // Always send empty strings for these 3 (as requested)
      formPayload.append("aadharFrontPage", "");
      formPayload.append("aadharBackPage", "");
      formPayload.append("panImage", "");

      // Still send the two PDFs if present
      formPayload.append("longQuestionnaire", formData.longQuestionnaire ? formData.longQuestionnaire : "");
      formPayload.append("membership", formData.membership ? formData.membership : "");

      const response = await singleUpload(formPayload);
      setPopupResponse(response);
      setDataIsSent(true);
      setLoading(false);

      // reset
      setFormData({
        ...initialFormData,
        aadharFrontPage: null,
        aadharBackPage: null,
        panImage: null,
      });
      setLoanEntries([{ loanAmount: "", loanSanctionDate: "", loanEndDate: "", loanType: "", lenderBranch: "", loanAccountNumber: "" }]);
      setCoverage("");
      setPremiumExcGST("");
      setImagePreviews({ longQuestionnaire: null, membership: null, aadharFrontPage: null, aadharBackPage: null, panImage: null });
      setOtpVerified(false);
      setResponses(initialResponses);
      setPhoneNumber("");
      setSingleManualForm(false);
      setOtp("");
      setOtpSent(false);
      setIsManual(false);
      setIsDigital(false);
      setHasAnyYesAnswer(false);
      setTotalLoanAmount(0);
      setErrors({});
      setImageErrors({ longQuestionnaire: "", membership: "" });
    } catch (error) {
      console.error("Error:", error, "new error");
      setDataIsNotSent(true);
      setLoading(false);
      setTimeout(() => setDataIsNotSent(false), 2000);
    }
  };
  const disabledWhenAutofilled = fetchedByAadhar;  // everything except Aadhaar & loan rows
// Simple modal to collect disable date
const DisableDateModal = ({ open, onClose, onConfirm, initialDate }) => {
  const [disableDateForLoan, setDisableDateForLoan] = useState(initialDate || "");

  if (!open) return null;

  return (
    <div className="disable-date-overlay" onClick={onClose}>
      <div className="disable-date-container" onClick={(e) => e.stopPropagation()}>
        <button className="disable-date-close" onClick={onClose}>×</button>
        <h3 className="disable-date-title">Provide effective date</h3>
        <p className="disable-date-description">
          Please select the date this loan is being disabled (YYYY-MM-DD)
        </p>
        <input
          className="disable-date-input"
          type="date"
          value={disableDateForLoan}
          onChange={(e) => setDisableDateForLoan(e.target.value)}
        />
        <div className="disable-date-actions">
          <button className="disable-date-btn cancel" onClick={onClose} type="button">
            Cancel
          </button>
          <button
            className={`disable-date-btn confirm ${!disableDateForLoan ? "disabled" : ""}`}
            onClick={() => onConfirm(disableDateForLoan)}
            type="button"
            disabled={!disableDateForLoan}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};


const confirmToggleLoanStatusWithDate = async (statusDate) => {
  // pendingToggleLoan should be set when modal opened
  if (!pendingToggleLoan) {
    setInfoMsg("No loan selected");
    setInfoVariant("error");
    setInfoOpen(true);
    return;
  }
  try {
    setShowDisableDateModal(false);
    setTogglingLoanId(pendingToggleLoan.id);
    // send API: include statusDate and faid (flashcode)
    await updateLoanStatus({
      loanId: pendingToggleLoan.id,
      faid: flashcode,
      status: "inactive",
      statusDate: statusDate, // YYYY-MM-DD
    });

    await refreshLoansOnly();
    setInfoMsg("Loan disabled successfully");
    setInfoVariant("success");
    setInfoOpen(true);
  } catch (err) {
    console.error("Error toggling loan status:", err);
    setInfoMsg("Failed to update loan status");
    setInfoVariant("error");
    setInfoOpen(true);
  } finally {
    setTogglingLoanId(null);
    setPendingToggleLoan(null);
    setDisableDateForLoan("");
  }
};


  return (
    <>
      {loading ? (
        <ClipLoader
          className="clip-loader"
          color="black"
          loading={loading}
          cssOverride={override}
          size={70}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <>
        <InfoModal
  isOpen={infoOpen}
  message={infoMsg}
  variant={infoVariant}
  onClose={() => setInfoOpen(false)}
  autoCloseMs={0}   // set to e.g. 2500 if you want autoclose
/>

          {dataIsSent && popupResponse && (
            <SuccessModal popupResponse={popupResponse} message="Data submitted successfully!" onClose={handleSuccessClose} />
          )}
          {dataIsNotSent && (
            <ErrorModal
              ErrorResponse={ErrorResponse}
              isOpen={dataIsNotSent}
              message="An error occurred. Please try again."
              onClose={handleErrorClose}
            />
          )}

          <div className="tirumala-dc-form" id="data-form">
            <img
              className="tirumala-page-image"
              src="https://storage.googleapis.com/flash-v2/assets/images/logo.png"
              alt="tirumala Logo"
            />

            {/* ONE-PAGE FORM (no Next/Previous) */}
            <form className="data-form-main" onSubmit={handleSubmit}>
              {/* Basic details (was first-part) */}
              <div className="first-part">
                  {fetchedByAadhar && !fetchingByAadhar && (
    <div style={{ fontSize: 17, marginTop: 1, marginBottom:4, color: "#f1c40f" }}>
      A customer already exists for this Aadhaar and we have autofilled details for you.  
      Please directly add new loan details.
    </div>
  )}
              <label>
  Member Aadhar No.:
  <input
    style={{ fontFamily: '"Josefin Sans", sans-serif' }}
    type="number"
    name="aadhar"
    value={formData.aadhar}
    onChange={handleChange}
  />
  {errors.aadhar && <span className="error">{errors.aadhar}</span>}

  {fetchingByAadhar && (
    <ClipLoader
      size={14}
      color="black"
      cssOverride={{ marginLeft: 8, display: "inline-block", verticalAlign: "middle" }}
    />
  )}

</label>
                <label>
                  Customer ID:
                  <input disabled = {disabledWhenAutofilled} style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="customerId" value={formData.customerId} onChange={handleChange} />
                  {errors.customerId && <span className="error">{errors.customerId}</span>}
                </label>

                <label>
                  First Name:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="firstname" value={formData.firstname} onChange={handleChange} />
                  {errors.firstname && <span className="error">{errors.firstname}</span>}
                </label>

                <label>
                  Last Name:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="lastname" value={formData.lastname} onChange={handleChange} />
                  {errors.lastname && <span className="error">{errors.lastname}</span>}
                </label>

                <label>
                  DOB (DD-MM-YYYY):
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleDobChange} />
                  {errors.dateOfBirth && <span className="error">{errors.dateOfBirth}</span>}
                </label>

                <label>
                  Age:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="age" value={formData.age} readOnly />
                  {ageLimitExceed && <span className="error">Max age allowed is 65</span>}
                </label>

                <label>
                  Gender:
                  <select  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} name="gender" value={formData.gender} onChange={handleChange}>
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  {errors.gender && <span className="error">{errors.gender}</span>}
                </label>

                <label>
                  Address:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="address" value={formData.address} onChange={handleChange} />
                  {errors.address && <span className="error">{errors.address}</span>}
                </label>

                <label>
                  Pincode:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="number" name="pincode" value={formData.pincode} onChange={handleChange} />
                  {errors.pincode && <span className="error">{errors.pincode}</span>}
                </label>

                <label>
                  State:
                  <input  disabled = {disabledWhenAutofilled} style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="state" value={formData.state} onChange={handleChange} />
                  {errors.state && <span className="error">{errors.state}</span>}
                </label>

                <label>
                  Mobile Number:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="number" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} />
                  {errors.mobileNumber && <span className="error">{errors.mobileNumber}</span>}
                </label>

                <label>
                  Email Id:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="email" name="emailId" value={formData.emailId} onChange={handleChange} />
                  {errors.emailId && <span className="error">{errors.emailId}</span>}
                </label>
              </div>

              {/* Secondary details + loans (was second-part) */}
              <div className="second-part">
                



                <label>
                  Member PAN Card:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="pan" value={formData.pan} onChange={handleChange} />
                  {errors.pan && <span className="error">{errors.pan}</span>}
                </label>

                <label>
                  Nominee Details Name:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="nomineeName" value={formData.nomineeName} onChange={handleChange} />
                  {errors.nomineeName && <span className="error">{errors.nomineeName}</span>}
                </label>

                <label>
                  Nominee Relationship:
                  <select  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} name="nomineeRelation" value={formData.nomineeRelation} onChange={handleChange}>
                    <option value="">Select Relationship</option>
                    <option value="son">Son</option>
                    <option value="daughter">Daughter</option>
                    <option value="father">Father</option>
                    <option value="mother">Mother</option>
                    <option value="spouse">Spouse</option>
                    <option value="brother">Brother</option>
                    <option value="sister">Sister</option>
                  </select>
                  {errors.nomineeRelation && <span className="error">{errors.nomineeRelation}</span>}
                </label>

                <label>
                  Nominee DOB (DD-MM-YYYY):
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="date" name="nomineeDob" value={formData.nomineeDob} onChange={handleNomineeDobChange} />
                  {errors.nomineeDob && <span className="error">{errors.nomineeDob}</span>}
                </label>

                <label>
                  Nominee Aadhar No.:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="number" name="nomineeAadharNo" value={formData.nomineeAadharNo} onChange={handleChange} />
                  {errors.nomineeAadharNo && <span className="error">{errors.nomineeAadharNo}</span>}
                </label>

                <label>
                  Nominee Pan No.:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="nomineePanNo" value={formData.nomineePanNo} onChange={handleChange} />
                  {errors.nomineePanNo && <span className="error">{errors.nomineePanNo}</span>}
                </label>

                <label>
                  Member Occupation:
                  <input  disabled = {disabledWhenAutofilled}  style={{ fontFamily: '"Josefin Sans", sans-serif' }} type="text" name="occupation" value={formData.occupation} onChange={handleChange} />
                  {errors.occupation && <span className="error">{errors.occupation}</span>}
                </label>

                {/* Loans */}

                {/* Existing Loans (read-only) */}
{existingLoans.length > 0 && (
  <div className="loan-summary-card">
    <div className="loan-summary-header">
      <div className="loan-summary-title">
        <span className="ls-title-text">Existing Loans on Record</span>
        <span className="ls-sub">Fetched from your Tirumala profile</span>
      </div>
      <div className="ls-total-pill">{formatINR(existingLoansTotal)}</div>
    </div>

    <div className="loan-summary-list">
   {existingLoans.map((l, i) => {
  const isActive = String(l.loanStatus).toLowerCase() === "active";
  const isThisToggling = togglingLoanId === l.id;

  return (
    <div
      className={`loan-summary-item ${isActive ? "" : "inactive"}`}
  key={
  l.id != null
    ? `loan-${l.id}`
    : `loan-${l.loanAccountNumber}-${l.loanSanctionDate}-${l.loanEndDate}-${l.loanAmount}-${l.loanType}-${l.lenderBranch}`
}

      style={{ position: "relative" }}
    >
      {/* --- Enable/Disable Button at top-right --- */}
      <button
        type="button"
        className="loan-status-btn"
        style={{ position: "absolute", top: "10px", right: "10px" }}
        title={isActive ? "Disable this loan" : "Enable this loan"}
        disabled={isThisToggling}
     onClick={async () => {
  const nextStatus = isActive ? "inactive" : "active";

  // If we're disabling, first ask for a date (your existing flow)
  if (nextStatus === "inactive") {
    setPendingToggleLoan(l);
    // prefill date to today if you want:
    const todayIso = new Date().toISOString().slice(0, 10);
    setDisableDateForLoan(todayIso);
    setShowDisableDateModal(true);
    return;
  }

  // If enabling, include a statusDate. Prefer loan.statusChangedDate if provided,
  // otherwise use today's date (YYYY-MM-DD).
  try {
    setTogglingLoanId(l.id);

    const todayIso = new Date().toISOString().slice(0, 10);
    // Use l.statusChangedDate if present (and a valid-looking date), else use today
    const candidate = (typeof l.statusChangedDate === "string" && l.statusChangedDate.trim())
      ? l.statusChangedDate.slice(0, 10) // ensure YYYY-MM-DD
      : todayIso;

    await updateLoanStatus({
      loanId: l.id,
      faid: flashcode,
      status: nextStatus,
      statusDate: candidate, // backend param (YYYY-MM-DD)
    });

    await refreshLoansOnly();
    setInfoMsg(`Loan enabled successfully`);
    setInfoVariant("success");
    setInfoOpen(true);
  } catch (err) {
    // surface server message when possible
    const message = err?.message || "Failed to update loan status";
    setInfoMsg(message);
    setInfoVariant("error");
    setInfoOpen(true);
  } finally {
    setTogglingLoanId(null);
  }
}}


      >
        {isThisToggling
          ? (isActive ? "Disabling..." : "Enabling...")
          : (isActive ? "Disable" : "Enable")}
      </button>

      <div className="lsi-line1">
        <span className="lsi-amount">{formatINR(l.loanAmount)}</span>
        <span className="lsi-type">{l.loanType || "—"}</span>
        <span className={`lsi-status ${isActive ? "ok" : "warn"}`}>
          {l.loanStatus || "—"}
        </span>
      </div>

      <div className="lsi-line2">
        <span className="lsi-field">
          <span className="k">Sanction</span>
          <span className="v">{dmy(l.loanSanctionDate) || "—"}</span>
        </span>
        <span className="lsi-field">
          <span className="k">Ends</span>
          <span className="v">{dmy(l.loanEndDate) || "—"}</span>
        </span>
        <span className="lsi-field">
          <span className="k">Branch</span>
          <span className="v">{l.lenderBranch || "—"}</span>
        </span>
        <span className="lsi-field">
          <span className="k">A/C</span>
          <span className="v mono">{l.loanAccountNumber || "—"}</span>
        </span>
      </div>
    </div>
  );
})}



    </div>

    <div className="loan-summary-note">
      These are read-only. Please add/adjust the loans below if you want them included in this certificate.
    </div>
  </div>
)}


                <div className="loan-amount-section">
                  {loanDetails.map((entry, index) => (
                    <div key={index} className="loan-amount-section-first">
                      <label>
                        Loan Amount:
                        <input
                          style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                          type="text"
                          name={`loanAmount_${index}`}
                          value={entry.loanAmount}
                          onChange={(e) => handleLoanChange(e, index)}
                        />
                        {errors[`loanAmount_${index}`] && <span className="error">{errors[`loanAmount_${index}`]}</span>}
                      </label>

                      <label>
                        Loan Sanction Date:
                        <input
                          style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                          type="date"
                          name={`loanSanctionDate_${index}`}
                          value={entry.loanSanctionDate}
                          onChange={(e) => handleLoanChange(e, index)}
                        />
                        {errors[`loanSanctionDate_${index}`] && (
                          <span className="error">{errors[`loanSanctionDate_${index}`]}</span>
                        )}
                      </label>

                      <label>
                        Loan End Date:
                        <input
                          style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                          type="date"
                          name={`loanEndDate_${index}`}
                          value={entry.loanEndDate}
                          onChange={(e) => handleLoanChange(e, index)}
                        />
                        {errors[`loanEndDate_${index}`] && <span className="error">{errors[`loanEndDate_${index}`]}</span>}
                      </label>

                      <label>
                        Loan Type:
                        <select
                          style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                          name={`loanType_${index}`}
                          value={entry.loanType}
                          onChange={(e) => handleLoanChange(e, index)}
                        >
                          <option value="">Select Loan Type</option>
                          <option value="Personal">Personal</option>
                          <option value="LAP">LAP</option>
                          <option value="Vehicle">Vehicle</option>
                          <option value="HomeLoan">Home Loan</option>
                          <option value="Others">Others</option>
                          <option value="deposit loan">Deposit Loan</option>
                          <option value="daily deposits loan">Daily Deposits loan</option>
                        </select>
                        {errors[`loanType_${index}`] && <span className="error">{errors[`loanType_${index}`]}</span>}
                      </label>

                      <label>
                        Lender Branch:
                        <select
                          style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                          name={`lenderBranch_${index}`}
                          value={entry.lenderBranch}
                          onChange={(e) => handleLoanChange(e, index)}
                        >
                          <option value="">Select Lender Branch</option>
                          {branchList.map((branch, i) => (
                            <option key={i} value={branch}>
                              {branch}
                            </option>
                          ))}
                        </select>
                        {errors[`lenderBranch_${index}`] && <span className="error">{errors[`lenderBranch_${index}`]}</span>}
                      </label>

                      <label>
                        Loan Account Number:
                        <input
                          style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                          type="text"
                          name={`loanAccountNumber_${index}`}
                          value={entry.loanAccountNumber}
                          onChange={(e) => handleLoanChange(e, index)}
                        />
                        {errors[`loanAccountNumber_${index}`] && (
                          <span className="error">{errors[`loanAccountNumber_${index}`]}</span>
                        )}
                      </label>

                      {index > 0 && (
                        <button type="button" className="delete-loan" onClick={() => handleDeleteLoan(index)}>
                          Delete
                        </button>
                      )}
                    </div>
                  ))}

                  <div className="loan-amount-section-second">
                    <button style={{ fontFamily: '"Josefin Sans", sans-serif' }} onClick={addMoreLoans}>Add More Loan Amounts</button>
                  </div>

       <div className="total-loan-amount-card">
  <h4>Total Loan Amount</h4>
  <p>₹ {totalLoanAmount.toLocaleString("en-IN")}</p>
</div>

                </div>

                <label>
                  <span  className="label-text">Policy Tenure:</span>
                  <select
                  style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                    value={tenure}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTenure(value);
                      const years = parseInt(value.split("_")[0], 10);
                      setShowPopup(years >= 3);
                    }}
                  >
                    {Object.keys(pricingData).map((key) => (
                      <option key={key} value={key}>
                        {key.replace(/_/g, " ")}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Policy Premium Inc GST:
                  <input
                    style={{ fontFamily: '"Josefin Sans", sans-serif' }}
                    type="text"
                    name="premiumIncGST"
                    value={formData.premiumIncGST}
                    onChange={handleChange}
                    disabled={true}
                  />
                  {errors.premiumIncGST && <span className="error">{errors.premiumIncGST}</span>}
                </label>

                {showPopup && (
                  <div className="popup-overlay" onClick={togglePopup}>
                    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                      <button className="close-button" onClick={togglePopup}>
                        ×
                      </button>
                      <p>
                        The premium amount displayed corresponds to a tenure of 3 years only. After
                        3 years, the policy will be renewed for the remaining years in a 3-year
                        cycle.
                      </p>
                      <p>
                        प्रदर्शित प्रीमियम रक्कम फक्त ३ वर्षांच्या कालावधीसाठी आहे. ३ वर्षांनंतर,
                        उर्वरित वर्षांसाठी पॉलिसी ३ वर्षांच्या कालावधीमध्ये नूतनीकरण केली जाईल.
                      </p>
                    </div>
                  </div>
                )}

                {/* Health dialog trigger */}
                <div>
                  {totalLoanAmount > 200000 && (
                    
                    <button type="button" onClick={() => setOpen(true)} style={styles.openButton}>
                      Digital DOGH Form
                    </button>
                  )}

                  <HealthDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    styles={styles}
                    isManual={isManual}
                    setIsManual={setIsManual}
                    isDigital={isDigital}
                    setIsDigital={setIsDigital}
                    otpVerified={otpVerified}
                    otpSent={otpSent}
                    resendTimer={resendTimer}
                    error={error}
              phoneNumber={phoneNumber || formData.mobileNumber}
                    onSendOTP={handleSendOTP}
                    onVerifyOTP={handleVerifyOTP}
                    onResendOTP={handleResendOTP}
                    onOtpChange={handleOtpChange}
                    healthQuestion={healthQuestion}
                    responses={responses}
                    handleResponseChange={handleResponseChange}
                    singleManualForm={singleManualForm}
                    imagePreviews={imagePreviews}
                    imageErrors={imageErrors}
                    handleFileChange={handleFileChange}
                    handleRemoveImage={handleRemoveImage}
                    pdfDownloadLink={pdfDownloadLink}
                    memmberShipFormLink={memmberShipFormLink}
                    isHealthFormValid={isHealthFormValid}
                    onSave={() => {
                      handleSubmitTnc();
                      setOpen(false);
                    }}
                  />
                </div>
              </div>

              {/* Single submit button (no Next/Previous) */}
            <div style={{ marginTop: 12 }}>
  {fetchedByAadhar ? (
    <button
      style={{ fontFamily: '"Josefin Sans", sans-serif' }}
      className={canUpdateLoans() ? "" : "grey-button-next"}
      disabled={!canUpdateLoans()}
      type="button"
      onClick={handleUpdateLoans}
    >
      Update Loans
    </button>
  ) : (
    <button
      style={{ fontFamily: '"Josefin Sans", sans-serif' }}
      className={areRequiredFieldsFilled() && areLoanDetailsFieldsFilled() ? "" : "grey-button-next"}
      disabled={!areRequiredFieldsFilled() || !areLoanDetailsFieldsFilled()}
      type="submit"
    >
      Submit
    </button>
  )}
</div>

            </form>
          </div>
          {/* Disable date modal */}
<DisableDateModal
  open={showDisableDateModal}
  onClose={() => {
    setShowDisableDateModal(false);
    setPendingToggleLoan(null);
    setDisableDateForLoan("");
  }}
  initialDate={disableDateForLoan}
  onConfirm={(date) => confirmToggleLoanStatusWithDate(date)}
/>

        </>
      )}
    </>
  );
};

export default TirumalaDC;
